import { EFinancingProgram } from '@if/core/types'
import MessageIcon from '@mui/icons-material/Message'
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Stack, Typography } from '@mui/material'
import { CreditApplication } from '@src/data/types'
import { useTranslation } from 'react-i18next'

interface Props {
  open: boolean
  creditApp: CreditApplication
  financingProgramId: EFinancingProgram
  onClose: () => void
}

const UnreadMessagesModal = ({ open, creditApp, financingProgramId, onClose }: Props) => {
  const { t } = useTranslation()

  const handleOpenChat = () => {
    window.open(`/chat-dashboard/${financingProgramId}/${creditApp.id}`, '_blank')
    onClose()
  }

  return (
    <Dialog open={open} onClose={() => {}} disableEscapeKeyDown maxWidth="sm" fullWidth>
      <DialogTitle>
        <Stack direction="row" alignItems="center" spacing={1}>
          <MessageIcon color="warning" />
          <Typography variant="h6">{t('common.unreadMessages', 'Unread Messages')}</Typography>
        </Stack>
      </DialogTitle>
      <DialogContent>
        <Typography variant="body1">
          {t('viewCreditApplication.unreadMessagesDescription', 'You have unread messages. Please review them.')}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleOpenChat} variant="contained" color="warning" startIcon={<MessageIcon />}>
          {t('common.messages', 'Messages')}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default UnreadMessagesModal
